import _ from 'lodash';
import fp from 'lodash/fp';
import { withRouter } from 'react-router';
import { withPropsOnChange } from 'recompose';

export default () =>
  fp.compose(
    withRouter,
    withPropsOnChange(['match'], ({ match, history }) => {
      const { channelId } = _.get(match, ['params']);
      return {
        channelId,
        history,
        pathTo: {
          orders: `/orders/${channelId}`,
          login: `/login/${channelId}`,
          main: `/${channelId}`,
        },
      };
    })
  );



// WEBPACK FOOTER //
// ../pos-master/packages/pos-hoc/src/withRouter.js